import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionPlanModelInterface } from 'src/app/interface/subscription-plan-model.interface';
import {
    SubscriptionTierModelInterface,
    SubscriptionTierModelResponse,
} from 'src/app/interface/subscription-tier-model.interface';
import { OpenIdProfileBase } from 'src/app/mixin/presets';
import { OpenIdService } from 'src/app/service/open-id.service';

@Component({
    selector: 'app-view-subscriptions-plans-tiers-tier',
    templateUrl: './tier.component.html',
    styleUrls: ['./tier.component.css'],
})
export class TierComponent extends OpenIdProfileBase implements OnInit {
    public formGroup = new FormGroup({
        label: new FormControl(),
        description: new FormControl(),
        amount: new FormControl(),
        period_unit: new FormControl(),
        period_count: new FormControl(),
        cycles: new FormControl(),
        sequence_number: new FormControl(),
    });

    private planId?: number;
    public planModel?: SubscriptionPlanModelInterface;
    private tierId: number = 0;
    public tierModel?: SubscriptionTierModelInterface;

    public message?: string;
    constructor(
        private httpClient: HttpClient,
        openIdService: OpenIdService,
        private route: ActivatedRoute
    ) {
        super(openIdService);
    }

    ngOnInit(): void {
        // need plan and tiers
        this.$openIdReady.subscribe(() => {
            this.route.params.subscribe((params) => {
                this.planId = Number(params['id']);
                this.tierId = Number(params['tier']);
                this.getPlan();
            });
        });
    }

    private getPlan() {
        this.httpClient
            .get<SubscriptionPlanModelInterface>(
                `subscription_plans/${this.planId}/`
            )
            .subscribe((planModel: SubscriptionPlanModelInterface) => {
                this.planModel = planModel;
                if (this.tierId > 0) {
                    this.getTier();
                } else {
                    this.tierModel = {
                        subscription_plan: this.planId,
                    } as SubscriptionTierModelInterface;
                }
            });
    }

    private getTier() {
        this.httpClient
            .get<SubscriptionTierModelInterface>(
                `subscription_tiers/${this.tierId}/`
            )
            .subscribe((tierModel: SubscriptionTierModelInterface) => {
                this.tierModel = tierModel;
                this.formGroup.setValue({
                    label: tierModel.label,
                    description: tierModel.description,
                    amount: tierModel.amount,
                    period_unit: tierModel.period_unit,
                    period_count: tierModel.period_count,
                    cycles: tierModel.cycles,
                    sequence_number: tierModel.sequence_number,
                });

                if (this.planModel!.subscriber_count > 0) {
                    this.formGroup.controls.sequence_number.disable();
                    this.formGroup.controls.period_unit.disable();
                    this.formGroup.controls.period_count.disable();
                    this.formGroup.controls.cycles.disable();
                }
            });
    }

    public validate() {
        if (this.formGroup.invalid) {
            return;
        }

        this.message = 'Saving ...';

        if (this.tierId > 0) {
            this.httpClient
                .put(`subscription_tiers/${this.tierId}/`, this.tierModel)
                .subscribe((response) => {
                    this.message = 'Saved';
                });
        } else {
            this.httpClient
                .post('subscription_tiers/', this.tierModel)
                .subscribe((response) => {
                    this.message = 'Created';
                });
        }
    }
}
